import { Group, Paper, Text, ThemeIcon } from '@mantine/core';
import type { PatientMeasurementField } from '../types';
import { formatMeasurementField } from '../utils/formatters';
import { getPatientMeasurementFieldIcon } from '../utils/measurementFieldIcons';

interface PatientMeasurementFieldTileProps {
  field: PatientMeasurementField;
}

export function PatientMeasurementFieldTile({
  field,
}: PatientMeasurementFieldTileProps) {
  const FieldIcon = getPatientMeasurementFieldIcon(field);

  return (
    <Paper withBorder radius='sm' p='sm' bg='gray.0'>
      <Group justify='space-between' align='center' wrap='nowrap' gap='md'>
        <Group
          align='center'
          gap='sm'
          wrap='nowrap'
          style={{ minWidth: 0 }}
        >
          <ThemeIcon size='md' radius='xl' variant='light' color='blue'>
            <FieldIcon size={14} strokeWidth={1.8} />
          </ThemeIcon>
          <Text size='sm' fw={600} truncate>
            {field.label}
          </Text>
        </Group>
        <Text size='sm' fw={600} style={{ whiteSpace: 'nowrap' }}>
          {formatMeasurementField(field)}
        </Text>
      </Group>
    </Paper>
  );
}
